import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  background-color: ${(props) => props.backgroundColor || "grey"};
  color: ${(props) => props.color || "white"};
  border-radius: 4px;
  font-size: 11px;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 700;
  width: max-content;
  padding: 2px 4px;
  text-transform: uppercase;
  line-height: 13px;
  z-index: 2;
  align-items: center;
  height: 18px;

  @media only screen and (min-width: 769px) {
    font-size: 13px;
    line-height: 20px;
  }
`;
